import React from "react";
import { notification } from "antd";
import i18n from "i18next";

import { GRAY_500 } from "../../constant/colors";
import PatientUpdatedRefreshButton from "./PatientUpdatedRefreshButton";

// Sticky "new data available" prompt shown when the viewed patient's data was refreshed.
// Keyed so repeated events don't stack. The Refresh button carries a timelapse loader that
// auto-dismisses the prompt when it completes; clicking Refresh reloads the page, and the
// default close (X) dismisses it. Styling matches the Figma "Notification/FN" design (node 4006:2448).
const NOTIFICATION_KEY = "patient-data-updated";
const NOTIFICATION_CLASS = "fn-patient-updated-notification";

// antd's default leave animation collapses the card's height while fading, which clips the button
// away separately from the text - replace it with a plain fade so the card exits as one unit.
const injectExitAnimationStyle = () => {
  const STYLE_ID = "fn-patient-updated-notification-style";
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    @keyframes fnPatientUpdatedFadeOut {
      from { opacity: 1; }
      to { opacity: 0; }
    }
    .ant-notification-notice.${NOTIFICATION_CLASS}.ant-notification-fade-leave.ant-notification-fade-leave-active {
      animation-name: fnPatientUpdatedFadeOut !important;
      animation-duration: 0.28s !important;
    }`;
  document.head.appendChild(style);
};

function showPatientUpdatedNotification() {
  injectExitAnimationStyle();

  const dismiss = () => notification.close(NOTIFICATION_KEY);
  const refresh = () => {
    dismiss();
    window.location.reload();
  };

  notification.open({
    key: NOTIFICATION_KEY,
    className: NOTIFICATION_CLASS,
    message: i18n.t("patient_updated.title"),
    description: <span style={{ color: GRAY_500 }}>{i18n.t("patient_updated.description")}</span>,
    duration: 0,
    style: { borderRadius: 12 },
    btn: <PatientUpdatedRefreshButton onRefresh={refresh} onTimeout={dismiss} />
  });
}

export default showPatientUpdatedNotification;
